import { HomeIntroduceComponent } from './home-introduce/home-introduce.component';
import { HomeResultsComponent } from './home-results/home-results.component';
import { HomeFeaturesComponent } from './home-features/home-features.component';
import { HomeTestimontionsComponent } from './home-testimontions/home-testimontions.component';
import { HomeSignupComponent } from './home-signup/home-signup.component';
import { HomeComponent } from './home.component';
import { HomeBannerComponent } from './home-banner/home-banner.component';
import { CommonModule } from '@angular/common';
import { WavesModule, CarouselModule } from 'angular-bootstrap-md';

export const HOME_COMPONENT_DECLARATIONS = [
  HomeComponent,
  HomeBannerComponent,
  HomeIntroduceComponent,
  HomeResultsComponent,
  HomeFeaturesComponent,
  HomeTestimontionsComponent,
  HomeSignupComponent,
];

export const HOME_COMPONENT_IMPORTS = [
  CommonModule,
  CarouselModule,
  WavesModule,
];

export const HOME_COMPONENT_ENTRY_COMPONENTS = [
  HomeBannerComponent,
  HomeComponent,
  HomeBannerComponent,
  HomeIntroduceComponent,
  HomeResultsComponent,
  HomeFeaturesComponent,
  HomeTestimontionsComponent,
  HomeSignupComponent,
];
